<template>
  <div>
    <label v-for="option in options">
      <input type="radio" v-model="model" :value="option.value">
      <span>{{ option.label }}</span>
    </label>
    <!-- <input-label :for="id" :label="label" :required="required"></input-label>
    <select :multiple="multiple" :id="id" v-model="model" ref="input">
      <option v-for="option in options" :value="option.value">{{option.label}}</option>
    </select> -->
    <error-message v-if="error" :message="error"></error-message>
  </div>
</template>

<script>
import InputLabel from '@/shared/Input/InputLabel'
import ErrorMessage from '@/shared/Input/ErrorMessage'
import HelpText from '@/shared/Input/HelpText'

export default {
  components: {
    InputLabel,
    ErrorMessage,
    HelpText,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `selectbox-${this._uid}`
      },
    },
    value: {
      type: String | Array | Object | Number,
      default: null,
    },
    options: {
      type: Array,
      default: [],
    },
    label: String,
    error: String,
    helpText: String,
  },
  data() {
    return {
      model: this.value,
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>
